<template lang="pug">
  #signUpSuccess
    .container-width.p-3
      h5.text-center.font-weight-bold.pb-5.mb-5 申請LINE個人化服務
      .icon
        .icon-area
          .icon-fail.mx-auto.text-center
            .mb-5
              .action
                .trophy.mx-auto
                  .circle.mb-5
                    img(
                      :src='crossImg',
                      alt='fail_cross_img'
                    )
            h4 查無符合資料
      .mb-3
        p 顧問綁定失敗。
        p.mb-0 貼心提醒
        p 當日加入成為會員的顧客，請於資料建檔完成後(約一週工作時間)再進行LINE綁定。
      .text-center.mb-3
        p.mb-0 {{ $companyName }}會員服務專線
        small 0800-668-800
        p.mb-0 服務時間(國定假日除外)
        small 每週一~週五 09:30~12:00 13:30~18:00
      .px-4
        button.button.btn-block.button_clickCustom.button_clickCustom-outline-primary(
          type="button",
          @click="backToLINE()"
        )
          | 返回官方帳號
          i.fas.fa-arrow-alt-circle-right.fa-lg.arrorIcon
</template>

<script>
import crossImgUrl from '@/assets/images/icon/icon_cross.png';

export default {
  name: 'saFail',
  data() {
    return {
      crossImg: crossImgUrl
    };
  },
  mounted() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);
  },
  methods: {
    backToLINE() {
      // 返回官方帳號連結
      window.location = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
    }
  }
};
</script>

<style lang="scss" scoped>
#signUpSuccess {
    background: url('~@/assets/images/bg/bg_fail.png')no-repeat center center;
    background-size: contain;
    background-position-y: 30%;
}
</style>
